import type { DataPointDomain } from "@/lib/building-domain";

// Building-level rows whose domain is one of these merge into a single Ulkoiset palvelut
// group (story #882) — the domain axis stays internal classification, not UI chrome.
const BUILDING_EXTERNAL_DOMAINS: ReadonlySet<DataPointDomain> = new Set([
  "palvelut",
  "ennuste",
]);

// A building-level row that would land in the Ulkoiset palvelut group — the rows Signaalit
// hides per-signal when their owning BuildingService is inactive (bug #1506). Equipment/zone
// rows are never external feeds, so they're never subject to that filter.
export function is_building_external_row(
  source_type: "zone" | "equipment" | "building",
  domain: DataPointDomain,
): boolean {
  return source_type === "building" && BUILDING_EXTERNAL_DOMAINS.has(domain);
}

export function signal_group_key(
  source_type: "zone" | "equipment" | "building",
  source_id: string,
  domain: DataPointDomain,
): string {
  if (source_type !== "building") return source_id;
  return is_building_external_row(source_type, domain)
    ? `${source_id}:ulkoiset`
    : `${source_id}:${domain}`;
}
